export const SIZES = {
  SMALL: 5,
  MEDIUM: 20,
  LARGE: 100,
};

export const DEFAULT_LABEL = "Data is being fetched...";
